import React, { useState } from "react";
import _PropTypes from "prop-types";
import LcFetch from "lib/shared/fetch";
import StripeForm from "components/payments/StripeForm";
import { setNonWalletErrors } from "components/payments/util";

export default function StripeUpgradeForm(props) {
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const {
    defaultErrorMessage,
    planCode,
    planId,
    upgradePrice,
    FormButtons,
    StripePaymentElement
  } = props;

  const upgradeSubscription = async (extraParams = {}) => {
    const body = {
      plan_id: planId,
      proration_date: upgradePrice.prorationDate
    };
    const fetchParams = {
      body: JSON.stringify({ ...body, ...extraParams }),
      method: "POST"
    };
    try {
      const response = await LcFetch("/subscription/upgrade", fetchParams);
      const json = await response.json();

      if (response.ok) {
        window.location.href = json.redirect_to;
      } else {
        setErrorMessage(json.errorMessage);
        setProcessing(false);
      }
    } catch (error) {
      setErrorMessage(error.body?.errorMessage || defaultErrorMessage);
      setProcessing(false);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setProcessing(true);
    upgradeSubscription();
  };

  const onSuccess = (result) => {
    const { id } = result.setupIntent;
    upgradeSubscription({ setup_intent_id: id });
  };

  const onError = (result) => {
    const { error } = result;
    setNonWalletErrors(error, setErrorMessage);
    setProcessing(false);
  };

  const onSubmission = () => {
    setProcessing(true);
    return true;
  };
  const onReady = (_element) => {};

  return (
    <div className="user-subscribe-sell__upgrade-subscription">
      <div
        data-pay-method="card"
        disabled={!errorMessage}
        style={{ display: errorMessage ? "block" : "none" }}
      >
        <StripeForm
          FormButtons={FormButtons}
          onReady={onReady}
          subscriptionType={planCode}
          onSuccess={onSuccess}
          onError={onError}
          onSubmission={onSubmission}
          disabled={processing}
          processing={processing}
          errorMessage={errorMessage}
          bodyClass="tw-mb-6"
          StripePaymentElement={StripePaymentElement}
        />
      </div>
      <form
        onSubmit={onSubmit}
        style={{ display: errorMessage ? "none" : "block" }}
      >
        <FormButtons
          disabled={processing || !upgradePrice.price}
          processing={processing}
        />
      </form>
    </div>
  );
}
